/**
 * From / Reply-To pair, shown identically wherever a sender appears — the field
 * summary, the picker modal rows, and anywhere else that has to prove which address a
 * send will actually leave from.
 */
export function SenderEnvelope({ from, replyTo }: { from: string; replyTo: string }) {
  return (
    <div className="space-y-0.5 text-xs text-gray-700 dark:text-gray-300 min-w-0">
      <p className="truncate" title={from}>
        <span className="text-gray-500 dark:text-gray-400">From:</span>{' '}
        <span className="font-mono">{from}</span>
      </p>
      <p className="truncate" title={replyTo}>
        <span className="text-gray-500 dark:text-gray-400">Reply-To:</span>{' '}
        <span className="font-mono">{replyTo}</span>
      </p>
    </div>
  );
}
